import styled, { css } from 'styled-components';

export const FlexAlign = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 16px;
`;

export const FilterContainer = styled(FlexAlign)`
  margin-bottom: 0;
`;

const wrapperFilterButtonModifiers = {
  active: () => css`
    background: #3E97D2;
    color: #FFFFFF;
    cursor: auto;
  `,
};

export const FilterButton = styled.button`
  ${({ isActive }) => css`
    background: #FFFFFF;
    border: 1px solid #3E97D2;
    color: #3E97D2;
    border-radius: 4px;
    display: flex;
    align-items: center;
    padding: 8px;
    margin-left: 8px;
    cursor: pointer;
    outline: 0;
    ${isActive && wrapperFilterButtonModifiers.active()};
  `}
`;

export const Title = styled.h3`
  letter-spacing: 0.3px;
  line-height: 21px;
  font-style: normal;
  font-weight: bold;
  font-size: 16px;
  color: #121212;
  margin: 0;
  padding: 0 16px;
  text-transform: uppercase;
`;
